// src/components/auth/Login.js
import React, { useState } from "react";
import { resetPassword } from "../../api/auth";
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from "../../api/AuthContext";
import Footer from "../Shared/Footer";
import Modal from "../Shared/Modal";
import Swal from "sweetalert2";
import { validatePassword } from "../../utils/helpers";


const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encrypted_token = queryParams.get("q");

  console.log(encrypted_token)

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(""); 
    setIsProcessing(true);
    if (password !== confirmPassword) {
        setError("Passwords do not match.");
        setIsProcessing(false);
        return; // Stop form submission
      }
    
      if (!validatePassword(password)) {
        setIsProcessing(false);
        setError("Password must be at least 8 characters long and include one uppercase letter, one lowercase letter, one number, and one special character.");
        return;
      }
    
    //   setIsProcessing(true);
    try {
      const response = await resetPassword(encrypted_token, password);
      setIsProcessing(false); 
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Password Changed Successfully, Please login to continue!.",
        confirmButtonColor: "#75c043"
    }).then((result) => {
        if (result.isConfirmed) {
            navigate("/login"); // Redirect to login page
        }
    });
    //   navigate('/user/');
    } catch (err) {
        console.log(err)
        setIsProcessing(false);
        let errorMessage = err.response?.data?.detail || "Something went wrong. Please try again.";

    // Check if the error contains "No data found for email"
    if (errorMessage.includes("No data found for email")) {
      errorMessage = "Email not registered with us";
    }
    setError(errorMessage);

    }
  };

  return (
    <div>
        {/* <SignupSuccessModal /> */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
            <div className="row">
                <div className="col-12">
                    <div className="breadcrumb-contain">
                        <h2 className="mb-2">Reset Password</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/">
                                        <i className="fa-solid fa-house"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Reset Password</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Breadcrumb Section End --> */}

    {/* <!-- log in section start --> */}
    <section className="log-in-section background-image-2 section-b-space">
        <div className="container-fluid-lg w-100">
            <div className="row">
                <div className="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                    <div className="image-contain">
                        <img src="../assets/images/inner-page/login.png" className="img-fluid" alt="" />
                    </div>
                </div>

                <div className="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                    <div className="log-in-box">
                        <div className="log-in-title">
                            <h3>Welcome To Reducarb</h3>
                            <h4>Enter your new password..</h4>
                        </div>

                        <div className="input-box">
                            <form className="row g-4" onSubmit={handleSubmit}>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="password" placeholder="Enter password" className="form-control" required value={password} onChange={(e) => setPassword(e.target.value)} />
                                        {/* <label htmlFor="username">Username</label> */}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="password" placeholder="Confirm password" className="form-control" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                        {/* <label htmlFor="username">Username</label> */}
                                    </div>
                                </div>

                                {/* <div className="col-12">
                                    <button className="btn btn-md cart-button text-white w-100 justify-content-center"
                                    
                        style={{
                          backgroundColor: "#3150A3",
                          fontWeight: "bold",
                        }}type="submit">Submit</button>
                                    {error && <p style={{ color: "red", fontSize:"14px !important", marginTop: "10px", textAlign: "center" }}>{error}</p>}
                                </div> */}
                                <div className="col-12">
    <button
        className="btn btn-md cart-button text-white w-100 justify-content-center"
        style={{
            backgroundColor: "#3150A3",
            fontWeight: "bold",
        }}
        type="submit"
        disabled={isProcessing} // Disable button while processing
    >
        {isProcessing ? (
            <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Processing...
            </>
        ) : (
            "Submit"
        )}
    </button>
    {error && (
        <p style={{ color: "red", fontSize: "14px", marginTop: "10px", textAlign: "center" }}>
            {error}
        </p>
    )}
</div>
                            </form>
                        </div>

                        <div className="sign-up-box">
                            <h4>Already have an account?</h4>
                            <a href="/login">Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- log in section end --> */}

    {/* {signupSuccess && (
        <Modal
          title="Signup Successful!"
          modalType="success"
          bodyText="Welcome! Your signup was successful. Please log in to continue."
          modalId="loginModal"
        />
      )} */}

    <Footer/>
    </div>
  );
};

export default ResetPassword;
